module.exports = __webpack_public_path__ + "static/img/member20.1345c06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member20.jpg
// module id = tA+9
// module chunks = 0